import { TeaserEntry } from "../helper/interfaces";
import React from "react";
import { Info } from "react-feather";

import { getAuthorNames } from "../helper/author";
import { getTeaserTypeIcons, getTeaserImageUrl, getTeaserImage1x1Url } from "../helper/images";
import CustomImage from "./ui/Image";
import { AdInformationInterface } from "../helper/PageInformationInterface";
import { useLoggedRouter } from "../helper/useLoggedRouter";
import { getLinkObjectFromTeaser } from "../helper/link";
import TeaserAdMarker from "./teaserAdMarker";

export interface TeaserData {
  teaser: TeaserEntry;
  className?: string;
  navigate?: (articleId: string, ressortId: string) => void;
  adInformation?: AdInformationInterface;
  ignoreLead?: boolean;
  isImportantTeaser?: boolean;
  showImage?: boolean;
  showResorts?: boolean;
  isAlreadyLinked?: boolean;
}

function TeaserMinimizedNN(data: TeaserData) {
  const [routerPush] = useLoggedRouter();
  const internalNavigate = async (e, linkObject) => {
    e.stopPropagation();
    e.preventDefault();

    if (linkObject.articleId || linkObject.ressortId) {
      if (data.navigate) {
        data.navigate(linkObject.articleId, linkObject.ressortId);
      } else {
        await routerPush(`/article/${encodeURIComponent(data.teaser.id)}`);
      }
    }
  };

  const isNN = process.env.NEXT_PUBLIC_APP_THEME === "nn";

  const teaser = data.teaser;

  const image = teaser?.images ? teaser.images[0] : undefined;
  const imageUrl = image && (isNN ? getTeaserImage1x1Url(image) : getTeaserImageUrl(image));

  const teaserClassName = `teaser teaser-minimized teaser-minimized-type-${
    teaser.type
  } ${imageUrl ? "teaser--image" : ""} ${
    teaser.featured ? "teaser--featured" : ""
  } ${data.className ? data.className : ""} 
  ${data.isImportantTeaser ? "teaser-minimized__important" : ""}`;

  const resortsData = teaser.ressort?.split(",") || [];

  let icons = getTeaserTypeIcons(teaser.teaserTypes);

  function renderContent() {
    const authorNames = getAuthorNames(teaser.authors);
    return (
      <div>
        {data.isImportantTeaser && (
          <span className="teaser-minimized__important-icon">
            <Info />
          </span>
        )}
        {data.isImportantTeaser && (
          <p className="teaser-minimized__important-title">
            +++ Eilmeldung +++
          </p>
        )}
        <div className="flex items-stretch">
          {imageUrl && (
            <div className="teaser-image">
              {data.showImage ? (
                <CustomImage
                  src={imageUrl}
                  //fill
                  layout="fill"
                  //height="100%"
                  //width="150px" height="100%"
                  objectFit="cover"
                  alt={image.title}
                  data-image-src={imageUrl}
                />
              ) : (
                <div className="teaser-image fallback-image">
                  <span></span>
                </div>
              )}

              {teaser.paid && !teaser.hidePlusIcon && (
                <div className="teaser-info">
                  <div className="icon-nnplus" aria-label="NN+"></div>
                </div>
              )}
            </div>
          )}
          <div className="teaser-body flex-1">
            <TeaserAdMarker adIdentifier={teaser.adIdentifier} />
            {teaser.subline && (
              <div className="">
                <div className="teaser-time">
                  {teaser.subline}
                </div>
              </div>
            )}

            {teaser.topline && (
              <div className="teaser-info">
                <div className="teaser-topline">
                  <div>{teaser.topline}</div>
                </div>
              </div>
            )}
            {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}
          </div>
        </div>
      </div>
    );
  }

  const linkObject = getLinkObjectFromTeaser(teaser);
  const webViewUrl = linkObject.externalLink;
  const isAlreadyLinked = data.isAlreadyLinked == true;

  return (
    <>
      {data.isAlreadyLinked && (
        <div
          key={`teaser-link-${teaser.id}`}
          className={teaserClassName}
          data-name={`article-${teaser.id}`}
        >
          {renderContent()}
        </div>
      )}
      {!webViewUrl && !isAlreadyLinked && (
        <a
          href={linkObject.internalLink}
          key={`teaser-link-${teaser.id}`}
          onClick={(e) => {
            internalNavigate(e, linkObject);
          }}
          data-name={`article-${teaser.id}`}
          className={teaserClassName}
        >
          {renderContent()}
        </a>
      )}
      {webViewUrl && !isAlreadyLinked && (
        <a
          href={webViewUrl}
          key={`teaser-link-${teaser.id}`}
          target="_blank"
          rel="noreferrer"
          data-name={`article-${teaser.id}`}
          className={teaserClassName}
        >
          {renderContent()}
        </a>
      )}
    </>
  );
}

export default TeaserMinimizedNN;
